import { render } from "./LeaseForm.vue?vue&type=template&id=163e9c77"
import script from "./LeaseForm.vue?vue&type=script&lang=js"
export * from "./LeaseForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__